import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-[2%] w-5/6" }

import {StepBack} from "lucide-vue-next";
import {Button} from "@/components/ui/button";
import RciTable from "@/components/tables/rci/RciTable.vue";
import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'RciView',
  setup(__props) {

const route = useRoute()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Button), {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"])),
      type: "button",
      class: "text-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(StepBack), { class: "mr-2 h-5 w-5" }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('building.back')), 1)
      ]),
      _: 1
    }),
    _createVNode(RciTable, {
      coverageId: Number(_unref(route).params.id)
    }, null, 8, ["coverageId"])
  ]))
}
}

})